import { CaseType } from 'src/graphql';

export const isAssigneeInCase = (caseObject: CaseType, viewerId: number) =>
  caseObject?.Reports?.some((report) => report.Assignee?.id === viewerId) ||
  false;
